export default __webpack_public_path__ + "search-on-phone-3e87a30b10253a07a2ad6a6476f9398e.digested.png";